import { render, staticRenderFns } from "./ChangePhoneVerification.vue?vue&type=template&id=452c643c&lang=html"
import script from "./ChangePhoneVerification.vue?vue&type=script&lang=js"
export * from "./ChangePhoneVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports